(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/navigation-menu/views/navigation-list-item-spacer.js') >= 0) return;  svs.modules.push('/components/components/navigation-menu/views/navigation-list-item-spacer.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.navigation_menu=_cmps.navigation_menu||{};
_cmps.navigation_menu.templates=_cmps.navigation_menu.templates||{};
svs.components.navigation_menu.templates.navigation_list_item_spacer = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"nav-list-item nav-list-item-spacer\"></li>\n";
},"useData":true});
Handlebars.partials['components-components-navigation_menu-navigation_list_item_spacer'] = svs.components.navigation_menu.templates.navigation_list_item_spacer;
})(svs, Handlebars);

 })(window);